import { NgModule } from '@angular/core';

import { CoreCommonModule } from '@core/common.module';
import { TorzsekDetailsModule } from '../../components/torzsek-details/torzsek-details.module';
import { SharedModule } from 'app/main/shared/shared.module';
import { TorzsekCimFormModule } from '../../components/torzsek-cim-form/torzsek-cim-form.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CardBasicModule } from 'app/main/ui/card/card-basic/card-basic.module';
import { TorzsekBasicTableModule } from '../../components/torzsek-basic-table/torzsek-basic-table.module';
import { InvoiceModule } from '../invoice/invoice.module';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TetelekToolbarModule } from '../../components/torzsek-basic-table/toolbars/tetelek-toolbar/tetelek-toolbar.module';
import { PenzugyiBizonylatokPipesModule } from 'app/main/shared/pipes/penzugyi-bizonylatok-pipes/penzugyi-bizonylatok-pipes.module';
import { RouterModule } from '@angular/router';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreSidebarModule } from '@core/components';
import { FindByKeyPipeModule } from 'app/main/shared/pipes/find-by-key-pipe/find-by-key.module';
import { CalendarModule } from 'primeng/calendar';
import { PartnerekBizonylatokTransformPipe } from '../dijbekero-eloleg-kimeno/dijbekero-eloleg-kimeno-partner-adatai/partnerek-bizonylatok-transform.pipe';
import { AnalitikaComponent } from './analitika.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';

const routes = [
  {
    path: '',
    component: AnalitikaComponent,
    // resolve: {
    //   data: ErtekesitesDetailsResolver,
    //   torzsek: ErtekesitesTorzsekResolver,
    // },
  },
];

@NgModule({
  declarations: [
    AnalitikaComponent
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    CoreSidebarModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    TetelekToolbarModule,
    NgxDatatableModule,
    TorzsekBasicTableModule,
    TorzsekDetailsModule,
    TorzsekCimFormModule,
    CardBasicModule,
    InvoiceModule,
    PenzugyiBizonylatokPipesModule,
    NgbModalModule,
    NgbModule,
    Ng2FlatpickrModule,
    NgSelectModule,
    //TorzsekDetailsModule,
    FindByKeyPipeModule,
    SharedModule,
    CalendarModule,
  ],
  exports: [AnalitikaComponent],
})
export class AnalitikaModule {}
